import React, { forwardRef, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

export const CustomTimeInput = forwardRef(({ date, onChange }, ref) => {
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);

    // 👇 Actualiza valores locales cuando cambia la `date`
    useEffect(() => {
        const h = date?.getHours() || 0;
        const m = date?.getMinutes() || 0;
        const s = date?.getSeconds() || 0;
        setHours(h);
        setMinutes(m);
        setSeconds(s);
    }, [date]);

    const handleHourChange = (e) => {
        let newHour = parseInt(e.target.value, 10);
        const newDate = new Date(date);
        newDate.setHours(newHour);
        onChange(newDate);
    };

    const handleMinuteChange = (e) => {
        const newMinutes = parseInt(e.target.value, 10);
        const newDate = new Date(date);
        newDate.setMinutes(newMinutes);
        onChange(newDate);
    };

    const handleSecondChange = (e) => {
        const newSeconds = parseInt(e.target.value, 10);
        const newDate = new Date(date);
        newDate.setSeconds(newSeconds);
        onChange(newDate);
    };

    const hourOptions = Array.from({ length: 24 }, (_, i) => i);
    const minuteOptions = Array.from({ length: 60 }, (_, i) => i);
    const secondOptions = Array.from({ length: 60 }, (_, i) => i);

    return (
        <div className="custom-time-input-container">
            <Form.Select value={hours} onChange={handleHourChange} className="form-control-sm">
                {hourOptions.map(h => (
                    <option key={h} value={h}>
                        {h.toString().padStart(2, '0')}
                    </option>
                ))}
            </Form.Select>
            <span className="time-separator">:</span>
            <Form.Select value={minutes} onChange={handleMinuteChange} className="form-control-sm">
                {minuteOptions.map(m => (
                    <option key={m} value={m}>
                        {m < 10 ? `0${m}` : m}
                    </option>
                ))}
            </Form.Select>
            <span className="time-separator">:</span>
            <Form.Select value={seconds} onChange={handleSecondChange} className="form-control-sm">
                {secondOptions.map(s => (
                    <option key={s} value={s}>
                        {s < 10 ? `0${s}` : s}
                    </option>
                ))}
            </Form.Select>
        </div>
    );
});


export const createRenderCustomHeader = (currentDate, setDateFn) => (props) => {
    const {
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled
    } = props;



    return (
        <div className="react-datepicker__header-top">
            <CustomTimeInput date={currentDate} onChange={setDateFn} />
            <div className="react-datepicker__header-bottom">
                <button
                    onClick={decreaseMonth}
                    disabled={prevMonthButtonDisabled}
                    className="react-datepicker__navigation--flecha"
                >
                    &lt;
                </button>
                <span className="react-datepicker__current-month">
                    {props.date.toLocaleString('es', { month: 'long', year: 'numeric' })}
                </span>
                <button
                    onClick={increaseMonth}
                    disabled={nextMonthButtonDisabled}
                    className="react-datepicker__navigation--flecha"
                >
                    &gt;
                </button>
            </div>
        </div>
    );
};

